// extracted by mini-css-extract-plugin
export default {"balanceWrapper":"Balance_balanceWrapper__rcUx9","title":"Balance_title__qPtYz","balance":"Balance_balance__ZGQwS"};